import { Button } from "primereact/button";
import React, { useRef, useState } from "react";
import { ReactComponent as CTA } from "../../assets/CTA.svg";
import { ReactComponent as Upload_icon } from "../../assets/upload_icon.svg";
import { ReactComponent as Vector } from "../../assets/Vector.svg";
import { ReactComponent as Sync_active } from "../../assets/Sync_active.svg";
import MobileView from "./MobileView";
import TextFileReader from "./TestFileReader";

const SourceUpload = ({ uploadedFile, setUploadedFile, setUrl,url }) => {
  const fileInputRef = useRef(null);
  const [mobileView, setMobileView] = useState("");
  const [URL, setURL] = useState("");

  const handleDivClick = () => {
    fileInputRef.current.click();
  };

  const handleFileSelect = (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    const allowedTypes = ["text/csv", "text/plain", "application/pdf"];
    const maxSize = 1 * 1024 * 1024; // 1MB
    let errorMessages = [];
    let validFiles = [];

    files.forEach((file) => {
      if (file.size > maxSize) {
        errorMessages.push(`${file.name}: File size should not exceed 1MB`);
        return;
      }

      if (!allowedTypes.includes(file.type)) {
        errorMessages.push(
          `${file.name}: Only CSV, TXT, or PDF files are allowed`
        );
        return;
      }

      validFiles.push(file);
    });

    if (errorMessages.length) {
      alert(errorMessages.join("\n"));
    }

    if (validFiles.length > 0) {
      // onFileSelect((prev) => [...prev, ...validFiles]);
      setUploadedFile(validFiles);
    }

    // Reset file input after processing
    e.target.value = "";
  };

  const handleUrlChange = (e) => {
    setUrl(e?.target?.value);
    setURL(e.target?.value);
  };

  const handleSyncClick = () => {
    setMobileView(URL);
  };
  return (
    <div className="border rounded-md">
      <div className="pt-3">
        <span className="text-lg font-medium">
          <Vector className="mx-1" />
          Provide the data to train your AI bot. Upload a “txt” file or paste a
          URL.
        </span>
      </div>
      <div
        className="flex justify-between mt-3"
        style={{ justifyContent: "space-between" }}
      >
        <div style={{ width: "40%" }}>
          <p className="text-start font-medium text-gray-800">Upload File</p>
          <div
            className="items-center justify-center rounded-lg border-4 border-dashed border-gray-400 px-4 py-10 cursor-pointer"
            onClick={handleDivClick}
          >
            <div className="flex items-center justify-center border border-red-500 p-3 space-x-4">
              <div className="w-1/12 flex justify-center">
                <Upload_icon />
              </div>
              <div className="w-80 text-gray-600 text-sm text-center break-words">
                Browse and choose the files you want to upload from your
                computer
              </div>
            </div>

            {/* CTA Button & Hidden File Input */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                paddingBottom: "10px",
              }}
            >
              <CTA />
              <input
                type="file"
                accept=".txt"
                multiple
                ref={fileInputRef}
                className="hidden"
                onChange={handleFileSelect}
              />
            </div>
          </div>
          <div class="divider-container">
            <div class="divider-line"></div>
            <span class="divider-text">OR</span>
            <div class="divider-line"></div>
          </div>
          <p className="text-start font-medium text-gray-800">Enter URL</p>
          <div className="flex justify-center items-center">
            {" "}
            <input
              type="url"
              className="w-full"
              onChange={handleUrlChange}
              value={URL}
              placeholder="Ex: https://app.skalebot.com"
              disabled={uploadedFile?.length > 0 ? true : false}
            />
            <Sync_active
              className="mt-1 mx-1 cursor-pointer"
              onClick={handleSyncClick}
            />
          </div>
        </div>
        <div style={{ width: "40%" }}>
          <div>{url && <MobileView url={url} />}</div>
          <div>{uploadedFile?.length > 0 && <TextFileReader files={uploadedFile} />}</div>
        </div>
      </div>
    </div>
  );
};

export default SourceUpload;
